<template>
    <div>
    <el-breadcrumb separator="/" class="bread">
      <!--  <el-breadcrumb-item :to="{ name: 'index' }">首页</el-breadcrumb-item>-->
        <el-breadcrumb-item  :to="{name:'materialManager'}">素材管理</el-breadcrumb-item>
        <el-breadcrumb-item>新增</el-breadcrumb-item>
    </el-breadcrumb>

            <el-form  :model="materiaForm" :rules="materiarules"  ref="materiaForm" label-width="100px" class="demo-ruleForm"  :label-position="labelposition">

                <el-form-item label="素材名称" prop="resources_name">
                    <el-input v-model="materiaForm.resources_name" :maxlength="20" style="width: 30%"></el-input>
                </el-form-item>



                <el-form-item  label="素材类型" prop="resources_type_id">
                    <el-select v-model="materiaForm.resources_type_id" placeholder="请选择素材类型" @change="onChangeResourcesType()">
                        <el-option
                                v-for="item in materiaTypeList"
                                :label="item.resources_type_name"
                                :value="item.resources_type_id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <!-----------------------------------------------------end-------------------------------------------------------------------->

                <el-form-item label="上传方式" prop="resource_upload_type" v-bind:class="{isUploadDsplay:isShowChangeUpload}">
                    <el-select v-model="materiaForm.resource_upload_type" placeholder="请选择上传方式" @change="onChangeFileUploadType"   >
                        <el-option
                                v-for="item in materiaTypeList2"
                                :label="item.label"
                                :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="图片">
                    <img :src="materiaForm.download_url" width="200px" id="img">
                </el-form-item>
                <el-form-item prop="fileList">
                    <el-upload
                        class="upload-demo"
                        ref="upload"
                        with-credentials
                        :action="uploadurl"
                        :data="upload_data"
                        :on-preview="handlePreview"
                        :on-remove="handleRemove"
                        :on-success="handleSuccess"
                        :before-upload="handlebefupload"
                            style="width: 35%;"
                        v-bind:class="{isUploadDsplay:isUpload}"
                        >
                        <span >
                            <el-button size="small" v-if="materiaForm.download_url==''" type="success">上传素材</el-button>
                            <el-button size="small" v-if="materiaForm.download_url!=''" type="success">更新素材</el-button>
                            <div slot="tip" class="el-upload__tip">大小不超过1GB</div>
                        </span>

                </el-upload>
                </el-form-item>
                <!--<el-form-item label="在线上传"   v-bind:class="{isUploadDsplay:isOnlineUpload} "  >
                    <el-input v-model="materiaForm.onlinePath" :maxlength="1000" ></el-input>
                </el-form-item>-->

              <!--  <el-form-item label="编辑图片" v-if="materiaForm.resources_type_id=='001'&&isorno">
                    <div style="width:300px;height:200px;display: inline-block">
                        <vueCropper
                                ref="cropper"
                                :img="vueCroInfo.filepath"
                                :outputSize="vueCroInfo.outputSize"
                                :outputType="vueCroInfo.outputType"
                                :autoCrop="vueCroInfo.autoCrop"></vueCropper>
                        <el-button style="margin-top: 5px;" type="primary" @click="finish()" class="btn" v-if="!shotForm.isScreenShot">确认截图</el-button>
                    </div>
                    <div style="width:300px;height:200px;display: inline-block" v-if="shotForm.isScreenShot">
                        <img style="width:300px;height:200px;" :src="shotForm.shotShowPath"/>
                    </div>

                </el-form-item>-->

                <!--<el-form-item label="备注" prop="remark">
                    <el-input type="textarea" v-model="materiaForm.remark" style="width: 30%"></el-input>
                </el-form-item>-->
                <!---------------------------------start end----------------->

                <!----------------------------end --------------------------->
                <el-form-item>
                    <el-button type="primary"  @click="submitForm('materiaForm')">确 定</el-button>
                    <!-- add tag-------------------------------->

                    <el-button @click="close()">取消</el-button>
                </el-form-item>
            </el-form>





        </div>
</template>
<script>
    //import VueCropper from 'VueCropper';

    export  default{

        data(){
            //tag====================================

            //tag====================================


            var validateFileList = (rule, value, callback) => {
               // var fileType=this.materiaForm.resource_upload_type;
                //console.log(value.length+"fileType"+fileType);

                if (this.materiaForm.download_url=='' ) {
                    callback(new Error('请选择资源...'));
                }else {
                    callback();
                }
            };

            return{
               // url:this.requetHost+"/broadcast/resource/addResource",
                uploadurl:this.fileURL+"/vueFeign/UplodFile",
                id:"",
                tenantId:this.getcookie("storeId"),
                isorno:false,
                isShowChangeUpload:true,
                isUpload:false,
                isOnlineUpload:true,
                upload_data:{
                    type:this.resUploadWay,
                    folder:"picture"
                },
                vueCroInfo:{
                    filepath:'',
                    outputSize:1,
                    outputType:"jpeg||png",
                    autoCrop:true
                },
                filename:"",
                filepath:"",
                materiaTypeList:[],
                materiaTypeList2:[
                   /* {
                    value:'0',
                    label:'在线上传'
                },*/
                    {
                        value:'1',
                        label:'本地上传'
                    }],
                labelposition:"left",
                materiaForm:{
                    resources_name:'',
                    resources_type_id:'',
                    remark:'',
                    resource_upload_type:'1',
                    fileList:[],
                    onlinePath:"",
                    fileMd5:"",
                    verifyLevel:"",
                    wcType:"0",
                    author_id:this.getcookie("username_client"),
                    author_name:this.getcookie("username_client"),
                    tenant_id:this.getcookie("storeId"),
                    file_url:"",
                    download_url:"",
                    resources_size:0,
                    feature:""
                },

                shotForm:{
                    shotFilePath:'',
                    shotShowPath:'',
                    isScreenShot:false
                },
                materiarules: {
                    resources_name: [
                            { required: true, message: '请输入资源名称', trigger: 'blur' },

                            { min: 0, max: 20, message: '长度在 1 到 20 个字符', trigger: 'blur' }
                        ],
//                    secondOrgId:[{validator: validateSecondOrg, trigger:'blur'}],
//                    orgId: [
//                        { required: true, message: '请输入机构编号', trigger: 'blur' },
//                        // { validator: validateOrgCode, trigger: 'blur' },
//                    ],
                    resources_type_id: [
                            { required: true, message: '请选择资源类型', trigger: 'change' }
                        ],

                    fileList: [
                        { validator: validateFileList, trigger: 'blur' },
                    ],
                    remark: [
                            { min: 0, max: 100, message: '长度在 1 到 100 个字符', trigger: 'blur' }
                        ]
                },


            }


        },
        created(){
            this.getResourcesTypeList();
        },methods:{
            close(){
                this.$router.push( {name:"materialManager",params:{}})
            },
            getResourcesTypeList(){
                this.$http.get(this.admin_host+"/material/admin/type/find/list?tenantId="+this.tenantId).then(response =>{
                    if(response.status==200){
                        this.materiaTypeList=response.body.Data.resourcesTypeList;
                         this.materiaForm.resources_type_id= this.materiaTypeList[0].resources_type_id
                    }
                },function(response){
                    this.$message({ showClose: true, message: '网络异常', type: 'error'
                    });
                });

            },
            submitForm(formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        /*var uploadWay=this.materiaForm.resource_upload_type;
                        if(uploadWay=='0'){
                            this.filepath=this.materiaForm.onlinePath
                            if(this.filepath==""){
                                this.$message({showClose: true,message: '在线地址不能为空',type: 'error'});
                                return false;
                            }
                        }*/
                        //=========================================================机构 start=============

                        /*var filePath = '';
                        if(this.shotForm.isScreenShot){
                            filePath=this.shotForm.shotFilePath;
                        }else{
                            filePath=this.filepath;
                        }*/

                        var params={
                            download_url:this.materiaForm.download_url,
                            resources_name:this.materiaForm.resources_name,
                            resources_type_id:this.materiaForm.resources_type_id,
                            resources_size:this.materiaForm.resources_size,
                            author_id:this.materiaForm.author_id,
                            file_url:this.materiaForm.file_url,



                            resources_md5:this.materiaForm.fileMd5,
                            author_name:this.materiaForm.author_name,
                            tenant_id:this.materiaForm.tenant_id,
                            feature:this.materiaForm.feature
                        }


                        this.$http.post(this.admin_host+"/material/admin/save",params).then((response)=>{
                            var data=response.body;
                            if(data.Code=="200"){
                                this.$message({showClose: true,message: '保存成功',type: 'success'});
                                this.$router.push({name:"materialManager"})
                            }else{
                                this.$message({showClose: true,message:data.Meta ,type: 'error'});
                            }
                        },()=>{
                            this.$message({showClose: true,message: '网络异常',type: 'error'});
                        })
                    }else{
                        console.log('error submit!!');
                        return false;
                    }
                });
            },
            //截图方法
          /*  finish(){
                this.$refs.cropper.getCropData((data) => {
                    //this.model = true;
                    //this.modelSrc = img;
                    this.$http.post(this.requetHost+"/fileUpload/uploadScreenShot",{imgStr:data,filename:this.filename}).then((response)=>{
                        this.shotForm.shotFilePath = response.body.downloadpath;
                        this.shotForm.shotShowPath = this.pushIp+response.body.downloadpath;
                        this.shotForm.isScreenShot = true;
                    },()=>{
                        this.$message({showClose: true,message: '网络异常',type: 'error'});
                    })
                })
            },*/

            getImg() {
                // 创建对象
                var img = new Image()

                // 改变图片的src
                img.src = this.materiaForm.download_url;
                // 加载完成执行
                var this_=this ;
                // 判断是否有缓存
                if (img.complete) {
                    // 打印
                  //  console.log(img.width + "*" + img.height);
                    this.materiaForm.feature = img.width + "*" + img.height;
                  //  alert('from:complete : width:' + img.width + ',height:' + img.height)
                } else {

                    img.onload = function () {
                        // 打印
                        console.log(img.width + "*" + img.height);
                        console.log(this_);
                        this_.materiaForm.feature = img.width + "*" + img.height;
                    //    alert('width:' + img.width + ',height:' + img.height)
                    }

                }
               //

            },

            //上传前
            handlebefupload(file) {
                var t = file.type.split("/");
                var n = file.name.split(".");
                var len = n.length;

                if(this.materiaForm.resources_type_id == "001"){
                    if(t[0]!="image") {
                        this.$message.error('只能选择图片格式!');
                        this.clear("upload");
                        this.isorno=false;
                        return false;
                    }
                };


                /*if(this.materiaForm.resource_type == null ||this.materiaForm.resource_type ==""){
                    this.$message.error('请先选择文件格式!');
                    this.clear("upload");
                    return false;
                }else{

                    if(this.materiaForm.resource_type == "1"){
                        console.log(t[0]!="video");
                        console.log(t[0]!="audio");
                        console.log(t[0]!="video" || t[0]!="audio");
                        if(t[0]!="video" && t[0]!="audio") {
                            this.$message.error('只能选择视频和音频格式!');
                            this.clear("upload");
                            this.isorno=false;
                            return false;
                        }
                    };
                    if(this.materiaForm.resource_type == '2'){
                        var filetype = n[len-1];
                        if(filetype.toUpperCase()!="ZIP"&&filetype.toUpperCase()!="RAR") {
                            this.$message.error('只能选择zip格式!');
                            this.clear("upload");
                            this.isorno=false;
                            return false;
                        }
                    }
                }*/

                if(this.materiaForm.fileList.length>=0){
                    this.isorno=true;

                };
               // this.materiaForm.resources_size=len
            },
            handleRemove(file, fileList) {
                this.materiaForm.fileList.length=0;
                this.isorno=false;
                this.shotForm.isScreenShot=false;
                this.$refs.cropper.clearCrop();
                console.log(file, fileList);
            },
            handlePreview(file) {
                console.log(file);
            },

           onChangeResourcesType(){
//              var resourceType= this.materiaForm.resource_type;
//              if(resourceType=='1'){
//                  //视频的时候展示
//                this.isShowChangeUpload=false;
//              }else{
//                  //其他类型的时候还原
//                  this.isShowChangeUpload=true;
//                  this.isUpload=false;
//                  this.isOnlineUpload=true;
//              }
            },
            onChangeFileUploadType(){
//                var fileType=this.materiaForm.resource_upload_type;
//                //console.log("onchange"+fileType);
//                if(fileType==='1'){
//                    this.isUpload=false;
//                    this.isOnlineUpload=true;
//                }else{
//                    this.isUpload=true;
//                    this.isOnlineUpload=false;
//                }
            },
            handleSuccess(response, file, fileList){
                this.materiaForm.fileList = fileList;
                this.filepath = response.path;
                this.materiaForm.resources_size=file.size
                this.materiaForm.download_url=response.path;
                this.materiaForm.file_url=response.path;

               this.getImg();
               // this.filename = response.fileName;
               //this.validateFileList(blur,fileList,);
                //this.materiaForm.fileMd5=response.fileMd5
                //this.$refs.materiaForm.validateField('fileList');
            },
            resetForm(formName) {
                this.$refs[formName].resetFields();
                this.isorno=false;
            },
            clear(name) {
                this.$refs[name].clearFiles();
            },





            selectEndTime(val){
                this.playbillForm.endTime=val;
            }
            //==================================================end=========================================================

        },
    }
</script>
<style>
.isable{
    display:none;
}
.isUploadDsplay{
        visibility:hidden;
    }
</style>


// WEBPACK FOOTER //
// MaterialAdd.vue?4e1d2799